import { Component, OnInit, AfterViewChecked } from "@angular/core";
import { UserfirestoreService } from "src/app/auth/fire-store/userfirestore.service";
import { catchError } from "rxjs/operators";
import { EMPTY, Subject } from "rxjs";
import * as AOS from "aos";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
  hover: boolean = false;
  inputVar: string = "";
  users$ = this.userFireStoreService.users$.pipe(
    catchError((err) => {
      this.errorMessageSubject.next(err);
      return EMPTY;
    })
  );

  private errorMessageSubject = new Subject<string>();
  errorMessage$ = this.errorMessageSubject.asObservable();

  constructor(private userFireStoreService: UserfirestoreService) {}

  ngOnInit() {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
    });
  }

  restartDelay() {
    this.hover = true;
  }
}
